var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.listConfig),function(item,index){return [(item.type == 'textarea')?_c('div',{key:`${item.prop}-${index}`,staticClass:"info-one-textarea"},[_c('div',{staticClass:"info-left"},[_vm._v(_vm._s(item.label))]),[(item.slot)?[_vm._t(item.prop,null,{"index":index,"item":item})]:(item.propInner && item.propInner != '')?_c('div',{staticClass:"info-right"},[_vm._v("\n          "+_vm._s(_vm.listData[item.prop]
              ? item.formatter
                ? item.formatter(
                    item.label,
                    _vm.listData[item.prop][item.propInner]
                  )
                : _vm.listData[item.prop][item.propInner]
              : "无")+"\n        ")]):_c('div',{staticClass:"info-right"},[_vm._v("\n          "+_vm._s(item.formatter
              ? item.formatter(item.label, _vm.listData[item.prop])
              : _vm.listData[item.prop]
              ? _vm.listData[item.prop]
              : "无")+"\n        ")])]],2):_c('div',{key:`${item.prop}-${index}`,staticClass:"info-one"},[_c('div',{staticClass:"info-left"},[_vm._v(_vm._s(item.label))]),[(item.slot)?[_vm._t(item.prop,null,{"index":index,"item":item})]:(item.propInner && item.propInner != '')?_c('div',{staticClass:"info-right"},[_vm._v("\n          "+_vm._s(_vm.listData[item.prop]
              ? item.formatter
                ? item.formatter(
                    item.label,
                    _vm.listData[item.prop][item.propInner]
                  )
                : _vm.listData[item.prop][item.propInner]
              : "无")+_vm._s(item.unit?item.unit:'')+"\n        ")]):_c('div',{staticClass:"info-right"},[_vm._v("\n          "+_vm._s(item.formatter
              ? item.formatter(item.label, _vm.listData[item.prop])
              : _vm.listData[item.prop]
              ? _vm.listData[item.prop]
              : "无")+_vm._s(item.unit?item.unit:'')+"\n        ")])]],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }